import { useState, useContext } from "react";
import { ReactSortable } from "react-sortablejs";
import ExperienceContext from "./ExperienceContext";
import {
	Navbar,
	Image,
	UnstyledButton,
	Text,
	Container,
	ScrollArea,
} from "@mantine/core";
import { useModals } from "@mantine/modals";
import add from "../../static/svg/add.svg";
import remove from "../../static/svg/remove.svg";
import editIcon from "../../static/svg/edit-pano-name.svg";
import AddPanoModal from "./AddPanoModal";
import UpdatePanoModal from "./UpdatePanoModal";
import { CDN_URL } from "../../constant";
import "../../index.css";

function PanoNav({
	opened,
	activePanoId,
	setActivePanoId,
	closeControls,
	isPreviewComponent,
}) {
	const { experience, setExperience, deletePanorama } =
		useContext(ExperienceContext);
	const [isAddModalOpen, setIsAddModalOpen] = useState(false);
	const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
	const [updateSceneDetails, setUpdateSceneDetails] = useState({});
	const modals = useModals();

	const openDeleteModal = (id) => {
		modals.openConfirmModal({
			title: "Please confirm your action",
			centered: true,
			styles: {
				modal: { backgroundColor: "#040F1F" },
				title: { color: "#ffffff", fontWeight: "700" },
			},
			children: (
				<Text size="sm">
					Are you sure you want to delete this scene?
				</Text>
			),
			labels: { confirm: "Delete", cancel: "Cancel" },
			confirmProps: { color: "red" },
			onConfirm: () => {
				deletePanorama(id);
				if (id === activePanoId) {
					setActivePanoId(experience[0]?.id);
				}
			},
		});
	};

	return (
		<>
			{isPreviewComponent && (
				<div className={`component ${isPreviewComponent ? 'fade-in' : 'fade-out'}`}>
					<Navbar
						p="xs"
						hiddenBreakpoint="sm"
						hidden={!opened}
						width={{ sm: 200, lg: 200 }}
						sx={(theme) => ({
							backgroundColor: theme.colors.ivisit_dark[0],
						})}
						style={{
							justifyContent: "space-between",
						}}
					>
						<ScrollArea offsetScrollbars scrollbarSize={6} py={10}>
							<ReactSortable
								list={experience}
								setList={setExperience}
								scrollSensitivity={50}
							>
								{experience.map((pano) => {
									return (
										<Container
											key={pano.id}
											px={10}
											py={10}
											style={{
												position: "relative",
												marginBottom: "10px",
												borderRadius: "5px",
												maxWidth: "250px",
											}}
											sx={(theme) => ({
												backgroundColor:
													theme.colors.ivisit_dark[1],
												"&:hover": {
													backgroundColor:
														theme.colors
															.ivisit_dark[2],
													cursor: "pointer",
												},
											})}
										>
											<Container
												px={0}
												py={0}
												onClick={() => {
													closeControls();
													setActivePanoId(pano.id);
												}}
											>
												<Image
													src={
														CDN_URL + pano.thumbUrl
													}
													alt={pano.name}
													radius={"sm"}
												/>
												<Text
													align="center"
													size="sm"
													style={{
														marginTop: "5px",
														color: "white",
													}}
												>
													{pano.name}
												</Text>
											</Container>
											<Container
												style={{
													display: "flex",
													flexDirection: "row",
													alignItems: "center",
													gap: "10px",
													position: "absolute",
													right: "5px",
													top: "20px",
													zIndex: 1,
												}}
											>
												<Image
													src={editIcon}
													width={12}
													onClick={() => {
														setUpdateSceneDetails(
															pano
														);
														setIsUpdateModalOpen(
															true
														);
													}}
												/>
												<Image
													src={remove}
													width={12}
													onClick={() => {
														openDeleteModal(
															pano.id
														);
													}}
												/>
											</Container>
										</Container>
									);
								})}
							</ReactSortable>
						</ScrollArea>
						<UnstyledButton
							style={{
								marginBottom: "10px",
								borderRadius: "5px",
								maxWidth: "250px",
							}}
							onClick={() => setIsAddModalOpen(true)}
							sx={(theme) => ({
								backgroundColor: theme.colors.ivisit_dark[1],
								"&:hover": {
									backgroundColor:
										theme.colors.ivisit_dark[2],
									cursor: "pointer",
								},
							})}
						>
							<Container
								direction="column"
								align={"center"}
								py={8}
							>
								<Container
									style={{
										border: "2px dotted",
										borderRadius: "5px",
									}}
									py={10}
								>
									<Image src={add} alt="Upload" width={40} />
								</Container>

								<Text
									size="sm"
									style={{ color: "white", marginTop: "3px" }}
								>
									Add Scene
								</Text>
							</Container>
						</UnstyledButton>
					</Navbar>
				</div>
			)}
			<div className={`component ${isPreviewComponent ? 'fade-in' : 'fade-out'}`}>
				<AddPanoModal
					isOpen={isAddModalOpen}
					setIsAddModalOpen={setIsAddModalOpen}
					closeControls={closeControls}
				/>
				<UpdatePanoModal
					isOpen={isUpdateModalOpen}
					setIsUpdateModalOpen={setIsUpdateModalOpen}
					closeControls={closeControls}
					updateSceneDetails={updateSceneDetails}
					setUpdateSceneDetails={setUpdateSceneDetails}
				/>
			</div>
		</>
	);
}

export default PanoNav;
